module.exports = __webpack_public_path__ + "static/media/palma-3.ccabd123.webp";